import { type ReactElement } from 'react';
import { Button } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';

interface GuardIndisponivelProps {
  onRetry: () => void;
}

/**
 * Estado de erro dos guards de rota (E70.F1). // ux-neutrality:allow doc-comment
 *
 * Quando o perfil NÃO RESPONDE, o guard não sabe se a pessoa é plataforma — e // ux-neutrality:allow doc-comment
 * "não sei" não é "não". Antes, a falha caía no `Navigate` para `/403`, que é a // ux-neutrality:allow doc-comment
 * resposta para a RECUSA, e o usuário lia "Acesso restrito" por um erro de rede. // ux-neutrality:allow doc-comment
 * Aqui a falha é dita como falha, com o caminho de volta na própria tela. // ux-neutrality:allow doc-comment
 */
export function GuardIndisponivel({ onRetry }: GuardIndisponivelProps): ReactElement {
  const t = ptBR.errorPages.perfilIndisponivel;
  return (
    <section
      role="alert"
      data-testid="guard-perfil-indisponivel"
      className="mx-auto flex max-w-md flex-col items-start gap-3 p-6"
    >
      <h1 className="text-heading-md text-fg">{t.title}</h1>
      <p className="text-body-md text-fg-muted">{t.body}</p>
      <Button
        variant="secondary"
        type="button"
        onClick={onRetry}
        data-testid="guard-tentar-novamente"
      >
        {t.retryCta}
      </Button>
    </section>
  );
}
